const generateRange = (start, end, length = end - start + 1) =>
    Array.from({ length }, (_, i) => start + i);


const generateYearRangeOptions = (start, end = null) => {
    const currentYear = new Date().getFullYear()
    let range = generateRange(start, end || currentYear);

    range.sort((a, b) => b - a);

    range = range.map((item) => {
        return { value: item, label: `${item}` };
    });

    range.unshift({ value: 0, label: "TBA" });

    return range;
};

export default generateYearRangeOptions
